import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitopandharpurakkalkottuljapur() {



const cardData = {
  keyword: " Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",

headingDescription:
  "Omshree Cab provides reliable and comfortable cab services from Mumbai to Pandharpur, Akkalkot, and Tuljapur — the three significant spiritual destinations in Maharashtra. Whether you are planning a pilgrimage trip, a family journey, or a group devotee tour, our cab service ensures a smooth, safe, and hassle‑free ride with professional drivers and well‑maintained vehicles. We offer flexible booking options including one‑way trips, round‑trip packages, and multi‑day plans at transparent per‑kilometer pricing. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With experienced chauffeurs skilled in highway and rural driving, punctual pickups from any location in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for dependable cab services to Pandharpur, Akkalkot, and Tuljapur pilgrimage destinations.",

topPlaces: [
  {
    title: "Pandharpur Vitthal Temple",
    description:
      "Pandharpur Vitthal Temple is the most revered pilgrimage site dedicated to Lord Vitthal (Vithoba) and attracts millions of devotees throughout the year, especially during Ashadi Ekadashi and Kartiki Ekadashi. Visitors can witness traditional aarti rituals, participate in devotional singing (bhajans), and experience the spiritual atmosphere on the banks of the Chandrabhaga River. Traveling by cab from Mumbai allows pilgrims to start their journey comfortably, avoid the stress of multiple transfers, and reach the temple conveniently for darshan and rituals."
  },
  {
    title: "Akkalkot Swami Samarth Temple",
    description:
      "The Swami Samarth Temple in Akkalkot is dedicated to Shri Swami Samarth Maharaj and is a significant spiritual center attracting devotees from across India. The temple complex includes the Samadhi of Swami Samarth, prayer halls, and sacred spaces for meditation and worship. A cab ride from Mumbai to Akkalkot enables devotees to reach the temple comfortably and maintain flexibility for timing, darshan, and seva activities, making the pilgrimage more accessible and peaceful."
  },
  {
    title: "Tuljapur Tulja Bhavani Temple",
    description:
      "Tulja Bhavani Temple in Tuljapur is one of Maharashtra’s most important Shakti Peethas, dedicated to Goddess Bhavani. Devotees visit to perform rituals, seek blessings for prosperity, and participate in traditional aarti ceremonies. The temple is known for its historic architecture, spiritual atmosphere, and cultural significance. Traveling by cab from Mumbai makes it easy to reach Tuljapur, plan visits to the temple and nearby ghats, and return conveniently without concerns about local transport."
  },
  {
    title: "Chandrabhaga River Ghats (Pandharpur)",
    description:
      "The Chandrabhaga River Ghats in Pandharpur are sacred riverbanks where devotees take holy dips, perform rituals, and offer prayers. The ghats play an important role during major festivals and pilgrimages, creating a vibrant spiritual environment. A cab service ensures comfortable travel from Mumbai, giving devotees enough time to engage in spiritual activities and return with peace of mind."
  },
  {
    title: "Akkalkot Sarvajanik Ganesh Temple",
    description:
      "The Sarvajanik Ganesh Temple in Akkalkot is a popular local religious site where devotees pay respects to Lord Ganesha before or after visiting the Swami Samarth Temple. The temple is known for its serene atmosphere and traditional rituals. Traveling by cab helps pilgrims include this spiritual stop easily as part of their Akkalkot pilgrimage itinerary."
  },
  {
    title: "Tuljapur River Ghats",
    description:
      "Tuljapur’s river ghats along the Bhima River provide peaceful surroundings for prayer, meditation, and spiritual reflection. Many devotees come here for holy dips before entering the temple complex. A comfortable cab ride from Mumbai allows travelers to plan sufficient time for both temple visits and river rituals without worrying about transport logistics."
  },
  {
    title: "Pandharpur Market & Local Culture",
    description:
      "Pandharpur’s local market area is vibrant with shops selling religious items, prasadam, sandals, and traditional Maharashtrian treats. It’s also a place to experience local culture and interact with fellow pilgrims. A cab service makes it convenient to explore the market and nearby eateries comfortably during your pilgrimage trip."
  },
  {
    title: "Akkalkot Town Sightseeing",
    description:
      "Akkalkot town has several local bazaars, historical spots, and small temples that visitors often explore after darshan. The local atmosphere reflects spiritual heritage and rural Maharashtrian life. Traveling by cab from Mumbai provides flexibility to include these local experiences in your itinerary."
  },
  {
    title: "Tuljapur Local Cuisine & Handicrafts",
    description:
      "Tuljapur boasts local eateries serving traditional Maharashtrian food, sweets, and regional specialties. Visitors can also explore shops offering handicrafts, religious souvenirs, and prayer items. A cab ride ensures an easy and comfortable visit to both the temple and local cultural spots."
  },
  {
    title: "Rest & Devotion Stops Along the Route",
    description:
      "The journey from Mumbai to Pandharpur, Akkalkot, and Tuljapur passes through scenic highways and historic towns ideal for breaks, meals, and meditation. A cab service lets you plan rest stops, refreshments, and local sightseeing along the way, making the pilgrimage trip more enjoyable and less tiring."
  }
],



services: [
{
name: "Mumbai to Pandharpur Cab",
description: "Mumbai to Pandharpur cab service provides comfortable and reliable transportation for devotees traveling to the famous Shri Vitthal Rukmini Temple in Pandharpur. The journey covers scenic highways of Maharashtra and is ideal for pilgrimage travelers seeking a peaceful spiritual trip. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, railway stations, and airports across Mumbai. Vehicles are spacious and well maintained for long-distance travel. Ideal for families, groups of devotees, and temple tour travelers. Air-conditioned vehicles ensure comfortable journeys throughout the trip."
},
{
name: "Mumbai to Pandharpur Taxi",
description: "Mumbai to Pandharpur taxi service offers convenient long-distance travel for devotees visiting the sacred temple town of Pandharpur. The taxi service ensures comfortable seating, smooth highway travel, and reliable transportation from Mumbai to the temple destination. Professional drivers provide safe driving and punctual pickup from homes, hotels, offices, and airport terminals. Ideal for religious journeys, family pilgrimages, and temple visits. Spacious vehicles ensure comfortable travel experiences. Flexible booking options allow passengers to schedule their spiritual trip easily."
},
{
name: "Mumbai to Pandharpur Cab Service",
description: "Mumbai to Pandharpur cab service offers dependable transportation for devotees planning a pilgrimage to Pandharpur. Vehicles are suitable for long-distance highway travel and provide comfortable seating and luggage space. Professional drivers ensure safe driving and timely pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airports. Ideal for temple visits, religious tours, and family pilgrimage journeys. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow convenient cab reservations."
},
{
name: "Mumbai to Pandharpur Taxi Fare",
description: "Mumbai to Pandharpur taxi fare options provide transparent pricing for passengers planning a spiritual journey to Pandharpur temple. The service offers economical travel plans based on distance, vehicle type, and travel duration. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, and airport terminals. Ideal for devotees, families, and temple travelers. Comfortable vehicles ensure relaxed journeys during long-distance travel. Clear pricing ensures affordable and transparent taxi fares."
},
{
name: "Mumbai to Pandharpur Cab Booking",
description: "Mumbai to Pandharpur cab booking allows devotees to reserve comfortable vehicles for temple visits and pilgrimage tours. Online and phone booking options provide quick confirmation and convenient travel planning. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, railway stations, and airports. Ideal for spiritual travelers visiting Pandharpur temple. Spacious vehicles ensure comfortable travel experiences. Flexible booking options allow easy ride reservations anytime."
},
{
name: "Pandharpur Temple Cab from Mumbai",
description: "Pandharpur temple cab from Mumbai provides reliable transportation for devotees traveling to the sacred Vitthal temple. Vehicles are suitable for long-distance journeys and provide comfortable seating for families and groups. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for temple visits, religious tours, and pilgrimage travel. Air-conditioned vehicles ensure relaxed journeys throughout the trip. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai to Akkalkot Cab",
description: "Mumbai to Akkalkot cab service offers comfortable transportation for devotees visiting the famous Akkalkot Swami Samarth temple. The journey covers major highways and provides a peaceful travel experience for spiritual travelers. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, and airports. Ideal for temple visits, pilgrimage tours, and family travel. Spacious vehicles ensure comfortable long-distance journeys. Flexible booking options allow convenient cab reservations."
},
{
name: "Mumbai to Akkalkot Swami Cab",
description: "Mumbai to Akkalkot Swami cab service provides reliable transportation for devotees visiting the sacred shrine of Swami Samarth in Akkalkot. Vehicles are well maintained and suitable for long-distance travel across Maharashtra. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, and airports in Mumbai. Ideal for spiritual journeys, temple visits, and family pilgrimages. Comfortable seating ensures relaxed travel experiences. Flexible booking options allow devotees to plan temple visits conveniently."
},
{
name: "Mumbai to Akkalkot Taxi Service",
description: "Mumbai to Akkalkot taxi service offers convenient travel for devotees planning a pilgrimage to the holy town of Akkalkot. Vehicles are suitable for long highway travel and provide comfortable seating and luggage space. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for temple visits, spiritual tours, and family travel. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow easy ride reservations."
},
{
name: "Mumbai to Tuljapur Cab",
description: "Mumbai to Tuljapur cab service provides reliable transportation for devotees visiting the famous Tulja Bhavani Temple in Tuljapur. The journey offers comfortable travel across major highways of Maharashtra. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, and airport terminals. Ideal for temple visits, pilgrimage travel, and religious tours. Comfortable vehicles ensure relaxed journeys for families and groups. Flexible booking options allow convenient travel planning."
},
{
name: "Tuljapur Bhavani Temple Cab Mumbai",
description: "Tuljapur Bhavani Temple cab from Mumbai offers convenient transportation for devotees visiting the sacred temple of Goddess Tulja Bhavani. Vehicles provide comfortable seating and smooth highway travel suitable for long journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for pilgrimage tours and spiritual travel. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow easy ride reservations."
},
{
name: "Mumbai Pandharpur Akkalkot Tuljapur Tour Cab",
description: "Mumbai Pandharpur Akkalkot Tuljapur tour cab service provides convenient transportation for devotees planning a multi-temple pilgrimage tour. This spiritual route covers major religious destinations across Maharashtra. Vehicles are spacious and suitable for extended journeys and group travel. Professional drivers ensure safe driving and reliable navigation across temple routes. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for pilgrimage groups and family temple tours. Flexible booking options allow customized travel itineraries."
},
{
name: "Mumbai to Pandharpur One Way Cab",
description: "Mumbai to Pandharpur one way cab service offers economical intercity transportation for devotees traveling to Pandharpur without return charges. Vehicles provide comfortable seating and smooth highway travel for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for temple visits, pilgrimage travel, and religious journeys. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow quick reservations."
},
{
name: "Mumbai to Pandharpur Round Trip Taxi",
description: "Mumbai to Pandharpur round trip taxi service offers convenient transportation for devotees planning a return pilgrimage journey. Vehicles are well maintained and suitable for long-distance highway travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, and airport terminals. Ideal for temple visits, family pilgrimages, and spiritual tours. Spacious seating ensures comfortable travel experiences. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Mumbai to Pandharpur Innova Cab",
description: "Mumbai to Pandharpur Innova cab service provides spacious and comfortable transportation for families and groups visiting Pandharpur temple. The Toyota Innova offers premium seating and smooth highway travel for long journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, and airport terminals. Ideal for group pilgrimage tours and family travel. Comfortable interiors ensure relaxed journeys. Flexible booking options allow convenient reservations."
},
{
name: "Mumbai to Pandharpur Ertiga Cab",
description: "Mumbai to Pandharpur Ertiga cab service offers comfortable MPV transportation for devotees traveling in small groups. The Maruti Ertiga provides spacious seating and smooth ride quality suitable for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for family temple visits and pilgrimage journeys. Air-conditioned interiors ensure comfortable travel experiences. Flexible booking options allow easy ride reservations."
},
{
name: "Religious Tour Cab Mumbai",
description: "Religious tour cab in Mumbai provides convenient transportation for devotees visiting temples and spiritual destinations across India. Vehicles are suitable for long-distance pilgrimage journeys and temple tours. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, railway stations, and airport terminals. Ideal for temple tours, spiritual journeys, and pilgrimage travel. Comfortable vehicles ensure relaxed journeys for devotees and families. Flexible booking options allow customized religious travel planning."
}
],

tableData: [
["Mumbai to Pandharpur Cab","Mumbai to Pandharpur Taxi"],
["Mumbai to Pandharpur Cab Service","Mumbai to Pandharpur Taxi Fare"],
["Mumbai to Pandharpur Cab Booking","Pandharpur Temple Cab from Mumbai"],
["Mumbai to Akkalkot Cab","Mumbai to Akkalkot Swami Cab"],
["Mumbai to Akkalkot Taxi Service","Mumbai to Tuljapur Cab"],
["Tuljapur Bhavani Temple Cab Mumbai","Mumbai Pandharpur Akkalkot Tuljapur Tour Cab"],
["Mumbai to Pandharpur One Way Cab","Mumbai to Pandharpur Round Trip Taxi"],
["Mumbai to Pandharpur Innova Cab","Mumbai to Pandharpur Ertiga Cab"],
["Religious Tour Cab Mumbai","Temple Tour Cab Service Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance pilgrimage routes from Mumbai to Pandharpur, Akkalkot, and Tuljapur. They are familiar with temple routes, highway travel, and local conditions, ensuring a smooth and comfortable spiritual journey."
  },
  {
    WhyChooseheading: "Transparent Pilgrimage Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Pandharpur, Akkalkot, and Tuljapur cab bookings. Customers receive clear information about per-kilometer charges, tolls, driver allowance, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our cab booking service operates 24 hours a day for pilgrimage travel. Whether you want to start early in the morning or travel overnight, Omshree Cabs provides reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized, ensuring a comfortable journey for families and pilgrims."
  },
  {
    WhyChooseheading: "Flexible Pilgrimage Travel Plans",
    WhyChoosedescription: "We offer flexible travel plans for Pandharpur, Akkalkot, and Tuljapur darshan including one-way travel, round trips, and multi-day pilgrimage packages."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group pilgrims."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your pilgrimage journey begins comfortably."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many devotees traveling from Mumbai to Pandharpur, Akkalkot, and Tuljapur. Our punctual service, experienced drivers, and comfortable vehicles ensure a peaceful spiritual trip."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Pandharpur, Akkalkot, and Tuljapur?", answer: "Yes, Omshree Cabs provides comfortable cab services from Mumbai for Pandharpur Vitthal Darshan, Akkalkot Swami Samarth Temple, and Tuljapur Bhavani Temple." },
  { question: "What is the distance from Mumbai to Pandharpur?", answer: "The distance from Mumbai to Pandharpur is approximately 400 km and the journey usually takes around 8 to 9 hours depending on traffic and road conditions." },
  { question: "Can I cover Pandharpur, Akkalkot, and Tuljapur in one trip?", answer: "Yes, many pilgrims combine Pandharpur, Akkalkot, and Tuljapur in one multi-day pilgrimage trip from Mumbai." },
  { question: "Which vehicles are available for the pilgrimage trip?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers depending on the group size." },
  { question: "Do you offer round trip cab services?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai for Pandharpur, Akkalkot, and Tuljapur." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for pilgrimage travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, temple visits, or rest breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during festival seasons like Ashadhi Ekadashi when Pandharpur receives many pilgrims." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Kulkarni",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Pandharpur and Akkalkot pilgrimage. The driver was experienced and the car was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishali Patil",
    feedback:
      "Our family trip to Pandharpur, Akkalkot, and Tuljapur with Omshree Cabs was very smooth. Excellent service and very professional driver.",
    rating: 5
  }
];















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",
  "description": "Omshree Cab offers reliable cab services from Mumbai to Pandharpur, Akkalkot, and Tuljapur for religious tours, temple visits, one-way trips, and round trips. Choose from Innova, Ertiga, and other comfortable vehicles for safe, punctual, and hassle-free travel across these pilgrimage destinations.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1250"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides cab services from Mumbai to Pandharpur, Akkalkot, and Tuljapur for religious tours, temple visits, one-way trips, and round trips. Choose Innova, Ertiga, and other comfortable vehicles for safe and hassle-free travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/107.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopandharpurakkalkottuljapur;